import ImageKit from 'imagekit-javascript';
import axiosInstance from './RequestsQueue'; // Adjust the import path

// SDK initialization
const imagekit = new ImageKit({
    publicKey: process.env.REACT_APP_IMAGEKIT_PUBLIC_KEY,
    urlEndpoint:process.env.REACT_APP_IMAGEKIT_URL_ENDPOINT,
    authenticationEndpoint: `${process.env.REACT_APP_SERVER_URL}/auth/imagekit` // Update this to your Flask server's auth endpoint
});
// Fetch authentication parameters from the server using axiosInstance
async function getAuthParameters() {
    try {
        const response = await axiosInstance.requestWithQueue({
            method: 'GET',
            url: `${process.env.REACT_APP_SERVER_URL}/auth/imagekit`, // Update this to your Flask server's auth endpoint
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching authentication parameters:", error);
        throw error;
    }
}

// Upload function with resizing for website banners
async function upload(file) {
    // console.log(file)
    const authParameters = await getAuthParameters();
    const timestamp = Math.floor(Date.now() / 1000); // Generate a unique timestamp in seconds
    const uniqueFileName = `${file.name.split('.')[0]}_${timestamp}.${file.name.split('.').pop()}`; // Add timestamp to filename

    return new Promise((resolve, reject) => {
        imagekit.upload({
            file: file,
            fileName: uniqueFileName,
            token: authParameters.token,
            signature: authParameters.signature,
            expire: authParameters.expire
        }, function (err, result) {
            if (err) {
                reject(err);
            } else {
                resolve({ url: result.url, id: result.fileId });
            }
        });
    });
}

export async function uploadMedia(file) {
    try {
        const result = await upload(file);
        return { url: result.url, id: result.id };
        // return { url: 'https://picsum.photos/536/359', id: '123435654321'};
    } catch (error) {
        console.error("Error uploading image:", error);
        return { error: "Error uploading image", details: error.message };
    }
}